import { render, staticRenderFns } from "./TelaCadastro.vue?vue&type=template&id=28b02241&"
import script from "./TelaCadastro.vue?vue&type=script&lang=js&"
export * from "./TelaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TelaCadastro.vue?vue&type=style&index=0&id=28b02241&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports